<template>
  <div class="popWrap nowOpen">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">휴대폰 본인인증</h1>
          </div>
          <div class="popBody full">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <!-- 약관 (s) -->
                <div class="termsWrap">
                  <div class="block accoHead">
                    <input type="checkbox" class="ipt" name="terms1" id="terms1_all" v-model="chkAll" />
                    <label for="terms1_all">전체동의</label>
                    <button type="button" class="btnIco_acco accoBtn">
                      <span>상세약관 보기</span>
                    </button>
                  </div>

                  <p class="txtXS pointC6 mb10">
                    고객 편의 제공을 위하여 여러 동의사항에 대한 '전체 동의' 기능을 제공하고 있습니다.
                  </p>

                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt" id="terms1_3" value="0" name="termsSub" v-model="chkSub" />
                          <label for="terms1_3">
                            <span>[필수]</span>
                            휴대폰 본인확인 이용약관 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms1_3').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt" id="terms1_4" value="1" name="termsSub" v-model="chkSub" />
                          <label for="terms1_4">
                            <span>[필수]</span>
                            통신사 이용약관 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms1_4').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt" id="terms1_2" value="2" name="termsSub" v-model="chkSub" />
                          <label for="terms1_2">
                            <span>[필수]</span>
                            고유식별정보처리 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms1_2').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt" id="terms1_1" value="3" name="termsSub" v-model="chkSub" />
                          <label for="terms1_1">
                            <span>[필수]</span>
                            개인 정보 수집/이용 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms1_1').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 약관 (e) -->

                <div class="formArea">
                  <span class="label">이름</span>
                  <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="authUser.userName" />

                  <span class="label">생년월일</span>
                  <div class="setBirth type2">
                    <input
                      type="tel"
                      class="ipt"
                      maxlength="6"
                      title="주민등록 앞 6자리 입력"
                      placeholder=""
                      v-model="ssn"
                      v-onlyNum
                      v-skipOfMax
                      nextTarget="ssn2"
                    />
                    <span class="sign" aria-hidden="true">-</span>
                    <input type="tel" class="ipt" maxlength="1" title="주민등록 뒤 1자리 입력" placeholder="" v-model="backSsn" v-onlyNum id="ssn2" />
                    <span class="sign" aria-hidden="true">******</span>
                  </div>

                  <span class="label">휴대폰번호</span>
                  <div class="setAgency">
                    <!-- 알뜰폰 선택 시 클래스추가 : selected -->
                    <ul class="iptGroup iptBtn">
                      <li>
                        <input
                          type="radio"
                          class="ipt"
                          name="rdosort"
                          id="agency_1"
                          checked="checked"
                          v-model="rvalue"
                          v-bind:value="1"
                          v-on:click="changeRdoData($event)"
                        />
                        <label for="agency_1">SKT</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          class="ipt"
                          name="rdosort"
                          id="agency_2"
                          v-model="rvalue"
                          v-bind:value="2"
                          v-on:click="changeRdoData($event)"
                        />
                        <label for="agency_2">KT</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          class="ipt"
                          name="rdosort"
                          id="agency_3"
                          v-model="rvalue"
                          v-bind:value="3"
                          v-on:click="changeRdoData($event)"
                        />
                        <label for="agency_3">LGU+</label>
                      </li>
                    </ul>
                    <select class="ipt" id="agency_4" title="통신사 선택" v-model="svalue" v-on:change="changeSltData($event)">
                      <option value="">알뜰폰</option>
                      <option value="5">SK알뜰폰</option>
                      <option value="6">KT알뜰폰</option>
                      <option value="7">LGU+알뜰폰</option>
                    </select>
                  </div>

                  <!--
                  <div class="setPhone">
                    <input
                      type="tel"
                      id="phone_2"
                      class="ipt"
                      title="휴대폰 번호 입력"
                      placeholder="' - ' 없이 입력해주세요."
                      value=""
                      v-model="authUser.mobile"
                      v-onlyNum
                    />

                    <button type="button" class="btn_s round s" @click="sendAuthNumber">
                      {{ authButtonTitle }}
                    </button>
                  </div>
                  -->
                  <div class="setAddr uiAct">
                    <div class="iptWrap">
                      <input
                        type="tel"
                        id="phone_2"
                        class="ipt notDel uiAct"
                        title="휴대폰 번호 입력"
                        placeholder="' - ' 없이 입력해주세요."
                        value=""
                        v-model="authUser.mobile"
                        v-onlyNum
                      />
                    </div>
                    <button type="button" class="btn_g m" @click="sendAuthNumber">{{ authButtonTitle }}</button>
                  </div>

                  <!--
                  <div v-show="authTime > 0 && !timeCheck">
                    <input type="tel" id="phone_3" class="ipt addTxt" title="인증번호 입력" v-model="authNum" v-onlyNum value="" />
                    <span class="txt">
                      유효시간
                      <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                    </span>
                  </div>
                  -->
                  <div class="uiAct" v-show="authTime > 0 && !timeCheck">
                    <div class="iptWrap addTxt">
                      <input
                        type="tel"
                        id="phone_3"
                        class="ipt notDel uiAct"
                        title="휴대폰 번호 입력"
                        placeholder=""
                        value=""
                        v-model="authNum"
                        v-onlyNum
                      />
                      <span class="txt">
                        <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="checkNumber" :disabled="regButtonShow">확인</button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <WebViewPop v-if="webViewPop" :pageName="pageName" @close="webviewClose" :type="webViewType">
      <div v-html="webView"></div>
      <template v-slot:closeButton>
        <button type="button" class="btnIco_close" @click="disagreement">
          <span>팝업 닫기</span>
        </button>
      </template>
    </WebViewPop>
  </div>
  <!-- popup (e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import { isEmpty, checkBackPeop } from '@/common/common.function';
import MessagePop from '@/components/popup/MessagePop';
import { AUTH_TIMEOUT } from '@/store/message.type';
import $ from 'jquery';
import * as customjs from '@/../static/js/m.front.js';
import WebViewPop from '@/components/popup/WebViewPop';

export default {
  name: 'authUserMobilePop',
  props: {},
  components: { MessagePop, WebViewPop },

  async mounted() {
    customjs.init();
    $('body').addClass('popOn');

    let webViews = await ApiService.service('GET', 'common/webView/WB000010');
    this.webViews = webViews.data.result;
    for (let url of this.webViews) {
      let res = await ApiService.service('GET', url.filePath);
      this.allUrl.push(res);
    }
  },
  data() {
    return {
      regButtonShow: true,

      //약관 관련
      chkAll: false, // 전체동의
      chkSub: [], // 필수, 선택 동의 여부
      agrAct0: true,
      chkSubNum: '-1',
      chkSubCnt: 0,

      webViewPop: false, // 웹뷰 팝업
      webViewUrl: '', // 웹뷰 URL
      webView: '',
      webViews: [], // 웹뷰 리스트
      webViewType: 'agree',
      pageName: null, // 웹뷰 타이틀
      allUrl: [],

      msg: '',
      messagePop: false,

      //본인인증관련
      authCheck: false, // 본인 인증 완료 여부
      tr_id: '',
      authKey: null, //인증번호qwer
      count: null, //제한시간
      time: '3:00', //인증시간text
      authButtonTitle: '인증번호요청', // 인증번호 버튼명 ( 인증번호요청 / 재요청 )
      authTime: 0, // 초기 세팅 시간 테스트로 10초로 설정 원래는 180초
      countDown: {},
      timeCheck: false,

      //유저정보
      yy: '',
      ssn: '',
      backSsn: '',
      uniqueKey: '',
      localCode: ['Y', 'N'],
      sexCode: ['RCSB000M', 'RCSB00WM'],
      cellCode: ['MBCP0001', 'MBCP0002', 'MBCP0003', 'MBCP0005', 'MBCP0006', 'MBCP0007'],
      rvalue: 1,
      svalue: '',
      authNum: null,
      authUser: {
        myPrdList: [],
        localUserYn: 'Y',
        sex: '1',
        userId: '',
        birth: '',
        userName: '',
        addrPost: '',
        addrRoad: '',
        addrRemark: '',
        addrJibun: '',
        mobile: '',
        userIdentityComp: '1',
      },
    };
  },
  watch: {
    chkSub() {
      console.log(this.chkSub);
      console.log(this.chkSub.length - this.chkSubCnt);

      if (this.chkSub.length - this.chkSubCnt == 1) {
        this.openPop(this.chkSub[this.chkSub.length - 1]);
      } else if (this.chkSub.length - this.chkSubCnt == -1) {
        const chk1 = this.chkSub.includes('0');
        const chk2 = this.chkSub.includes('1');
        const chk3 = this.chkSub.includes('2');
        const chk4 = this.chkSub.includes('3');

        if (this.chkAll) {
          if (!chk1 || !chk2 || !chk3 || !chk4) {
            this.agrAct0 = false;
            this.chkAll = false;
          }
        }
      }
      this.chkSubCnt = this.chkSub.length;
      console.log(this.chkSubCnt);
    },
    chkAll() {
      console.log('chkAll' + this.agrAct0);
      if (this.agrAct0 == false) {
        this.agrAct0 = true;
        return false;
      }

      this.chkSub = [];

      if (this.chkAll) {
        this.openPop(-1);
        const array_termsSub = document.getElementsByName('termsSub');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub = this.chkSub.filter(item => item !== array_termsSub[i].value);
        }

        const array_termsSub2 = document.getElementsByName('termsSub');

        for (let i = 0; i < array_termsSub2.length; i++) {
          console.log(array_termsSub2[i].value);
          this.chkSub.push(array_termsSub2[i].value);
        }
      }
    },
    backSsn() {
      let data = checkBackPeop(this.backSsn);
      this.authUser.sex = data._sex;
      this.authUser.localUserYn = data._local;
      this.yy = data._yyyy;
    },
    authTime() {
      if (this.authTime == 0) {
        this.authButtonTitle = '인증번호요청'; // 버튼 타이틀 초기값으로 변경
        clearInterval(this.countDown); // 카운트다운 초기화
        this.errorCode = null; // API 통해 리턴 받은 에러 코드 값 초기화
        this.authKey = null; // 인증번호 입력란 초기화
        this.authNum = null;
        this.timeCheck = false;

        this.msg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
        this.messagePop = true;
      }
    },
    authNum() {
      if (this.authNum.length > 0) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
  computed: {},
  methods: {
    validate: function() {
      if (this.chkSub.length < 4) {
        this.msg = '본인인증을 위한 약관에<br>동의해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }

      if (isEmpty(this.authUser.userName)) {
        this.msg = '이름을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      if (isEmpty(this.ssn)) {
        this.msg = '생년월일을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      return true;
    },
    changeRdoData: function(evt) {
      console.log(evt.target.value);
      this.svalue = '';
      this.rvalue = evt.target.value;
      this.authUser.userIdentityComp = evt.target.value;
    },
    changeSltData: function(evt) {
      console.log(evt.target.value);
      this.rvalue = '';
      this.svalue = evt.target.value;
      this.authUser.userIdentityComp = evt.target.value;
    },
    //인증번호 요청
    sendAuthNumber: function() {
      if (!this.validate()) {
        return false;
      } //데이터 체크

      // API 호출
      ApiService.service('POST', 'external/verification', {
        request: {
          cellNum: this.authUser.mobile,
          customerName: this.authUser.userName,
          sex: this.authUser.sex,
          localUserYn: this.authUser.localUserYn,
          //orderId: '121312313123',
          ssn: this.yy + this.ssn,
          userIdentityComp: this.authUser.userIdentityComp,
        },
        serviceType: 'app',
      })
        .then(response => {
          console.log(response.data);
          if (response.data.isSucceed) {
            this.timeCheck = false;
            this.authNum = response.data.result.authNum;
            this.uniqueKey = response.data.result.uniqueKey;

            //시간
            this.authButtonTitle = '재요청'; // 인증 진행시 버튼 TITLE 변경
            this.authTime = 180;
            clearInterval(this.countDown); // 재 요청시 시간 초기화 필요
            this.countDown = setInterval(() => {
              this.authTime--;
            }, 1000);
          } else {
            this.msg = response.data.error;
            this.messagePop = true;
          }
        })
        .catch(response => {
          console.log(response);
        });
    },
    checkNumber: function() {
      if (!this.validate()) {
        return false;
      } //데이터 체크

      if (this.authNum.length != 6) {
        this.msg = `입력받은 인증번호 6자리를 입력해주세요`;
        this.messagePop = true;
      }

      // API 호출
      ApiService.service('PUT', 'external/verification', {
        request: {
          authNum: this.authNum,
          cellNum: this.authUser.mobile,
          customerName: this.authUser.userName,
          uniqueKey: this.uniqueKey,
          sex: this.authUser.sex,
          localUserYn: this.authUser.localUserYn,
          ssn: this.authUser.birth,
          userIdentityComp: this.authUser.userIdentityComp,
        },
        serviceType: 'app',
      })
        .then(response => {
          console.log(response.data);
          if (!isEmpty(response.data.error)) {
            this.msg = response.data.error; // API에서 response 해주는 message
            this.errorCode = response.data.errorCode; // API에서 response 해주는 errorCode
          } else {
            //this.msg = '휴대폰 본인 인증이 완료되었습니다.'; // API에서 response 해주는 message

            clearInterval(this.countDown); // 재 요청시 시간 초기화 필요
            this.authCheck = true;
            //휴대폰 번호 저장
            ApiService.service('PUT', 'user/auth/mobile', {
              request: {
                mobile: this.authUser.mobile,
                uniqueKey: this.uniqueKey,
                telecom: this.authUser.userIdentityComp,
                sexCode: this.authUser.sex == 1 ? 'RCSB000M' : 'RCSB00WM',
                birth: this.yy + this.ssn,
                name: this.authUser.userName,
              },
              serviceType: 'app',
            })
              .then(response => {
                console.log(response.data);
                if (!isEmpty(response.data.error)) {
                  this.msg = response.data.error; // API에서 response 해주는 message
                  this.errorCode = response.data.errorCode; // API에서 response 해주는 errorCode
                } else {
                  let userInfo = JwtService.getUserInfo();
                  userInfo.mobile = this.authUser.mobile;
                  JwtService.setUserInfo(userInfo);
                  this.msg = '휴대폰 본인 인증이 완료되었습니다.'; // API에서 response 해주는 message

                  clearInterval(this.countDown); // 재 요청시 시간 초기화 필요
                  this.authCheck = true;
                }
                this.messagePop = true;
              })
              .catch(response => {
                console.log(response);
              });
          }
          this.messagePop = true;
        })
        .catch(response => {
          console.log(response);
        });
    },
    close() {
      this.messagePop = false;
      if (this.authCheck) {
        let user = [];
        user.mobile = this.authUser.mobile;
        user.telecomCompCode = 'MBCP000' + this.authUser.userIdentityComp;
        user.err = this.errorCode;
        this.$emit('callAuthNum', user);
      }
    },
    async openPop(num) {
      //this.pageName = pageName;
      if (this.webViewPop) return false;
      this.webViewPop = true;
      this.chkSubNum = num;
      console.log(num);
      if (num < 0) {
        if (num == -1) {
          this.pageName = '전체 약관';
        }

        let html = '';
        for (let i = 0; i < this.allUrl.length; i++) {
          let res = this.allUrl[i];
          html += res.data;
        }

        this.webView = html;
      } else {
        this.webViewUrl = this.webViews[num].filePath;
        this.pageName = this.webViews[num].pageName;
        let res = this.allUrl[num];
        this.webView = res.data;
        this.webViewPop = true;
      }
    },
    webviewClose() {
      console.log(this.chkSubNum);
      const chk1 = this.chkSub.includes('0');
      const chk2 = this.chkSub.includes('1');
      const chk3 = this.chkSub.includes('2');
      const chk4 = this.chkSub.includes('3');
      if (!this.chkAll && chk1 && chk2 && chk3 && chk4) {
        this.agrAct0 = false;
        this.chkAll = true;
      }
      this.webViewPop = false;
    },
    disagreement() {
      let num = this.chkSubNum.toString();
      console.log(num);
      if (num == -1) {
        this.agrAct0 = true;
        this.chkAll = false;
      } else if (num == -3) {
        this.chkSub2All = false;
      } else if (num == -4) {
        this.chkSub3All = false;
      } else if (num == '8') {
        this.agreeCollection = false;
      } else if (num == '9') {
        this.agreeCredit = false;
      } else {
        for (let i = 0; i < this.chkSub.length; i++) {
          if (num == this.chkSub[i].toString()) {
            this.chkSub.splice(i, 1);
          }
        }
      }

      console.log(this.chkSub);
      this.webViewPop = false;
    },
  },
};
</script>
=
